<template>
  <div class="cart-wrap--all">
    <div class="cart-wrap--content">
      <basketOrderComponent/>
      <section class="recipient">
        <div class="cart-container">
          <div class="cart__title-wrap">
            <div class="cart__title-number">1</div>
            <div class="cart__title">Данные получателя</div>
          </div>
          <div class="recipient__check">
            <template v-if="Object.keys(userData).length > 0">
              <div class="recipient__check-title">Получать буду не я</div>
              <div class="recipient__check-wrap">
                <input type="checkbox" id="recipient1" name="recipient" v-model="order.any_receive"
                       :disabled="loading"/>
                <label for="recipient1">
                  <div class="recipient__check-round"></div>
                </label>
              </div>
            </template>
          </div>
          <div class="recipient-content--1" :class="{'active': !order.any_receive}" v-if="!order.any_receive">
            <div class="recipient__user">
              <div class="recipient__user-img">
                <svg
                    width="17"
                    height="20"
                    viewBox="0 0 17 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.59066 0.0690954C6.37896 0.274677 5.18454 0.936779 4.41733 1.82818C2.53743 4.01242 2.64026 7.16776 4.65711 9.18465C6.66771 11.1952 9.83171 11.3023 12.0033 9.43328C12.6731 8.85675 13.2918 7.92178 13.5719 7.06285C14.3845 4.57053 13.2781 1.83842 10.9687 0.63466C9.90819 0.0817939 8.70404 -0.119795 7.59066 0.0690954ZM9.04849 1.5908C11.1098 1.90975 12.5594 3.86205 12.2592 5.91498C11.8576 8.66199 8.80154 10.1031 6.44857 8.65507C5.10334 7.82721 4.38371 6.22282 4.67645 4.7041C5.07742 2.6239 6.9781 1.27045 9.04849 1.5908ZM13.5202 10.0074C13.4084 10.0628 13.2759 10.1764 13.2258 10.2599C12.9815 10.6668 13.05 10.9298 13.5385 11.4603C14.6204 12.6352 15.2609 14.1257 15.3647 15.7097C15.4058 16.3368 15.362 16.4632 14.979 16.8214C13.5075 18.198 9.18 18.8419 5.5464 18.225C3.97577 17.9584 2.5836 17.4242 1.96364 16.8502C1.55748 16.4742 1.50981 16.3469 1.54709 15.7383C1.64329 14.166 2.28913 12.6344 3.33147 11.5067C3.72031 11.0861 3.80843 10.9146 3.77731 10.6388C3.71925 10.1238 3.13695 9.79231 2.69404 10.0223C2.50986 10.1179 1.98259 10.6785 1.63574 11.1474C0.655978 12.472 0.0929626 14.0637 0.00739197 15.7509C-0.039073 16.6666 0.126344 17.1408 0.708167 17.7599C2.7724 19.9564 9.14541 20.6996 13.55 19.2576C14.7559 18.8627 15.6363 18.3649 16.2122 17.752C16.7861 17.1413 16.9518 16.663 16.9056 15.7509C16.8025 13.7189 15.9909 11.7984 14.6416 10.3936C14.1597 9.89187 13.9202 9.80943 13.5202 10.0074Z"
                      fill="#8A9B6E"
                  />
                </svg>
              </div>
              <div class="recipient__user-name">
                {{ userData.NAME }} {{ userData.LAST_NAME }}
              </div>
              <div class="recipient__user-phone">
                {{ userData.PHONE_NUMBER }}
              </div>
              <div class="recipient__user-sl">|</div>
              <div class="recipient__user-mail">
                {{ userData.EMAIL }}
              </div>
            </div>
          </div>
          <form class="recipient-content--2" :class="{'active': order.any_receive}" v-if="order.any_receive">
            <div class="recipient-content__input-wrap">
              <div class="recipient-content__input">
                <label for="host-name">Имя*</label>
                <input
                    type="text"
                    id="host-name"
                    name="host"
                    placeholder="Введите имя"
                    v-model="order.customer.name"
                    :disabled="loading"
                    required
                />
              </div>
              <div class="recipient-content__input">
                <label for="host-surname">Фамилия*</label>
                <input
                    type="text"
                    id="host-surname"
                    name="host"
                    placeholder="Введите фамилия"
                    v-model="order.customer.lastname"
                    :disabled="loading"
                    required
                />
              </div>
            </div>
            <div class="recipient-content__input-wrap">
              <div class="recipient-content__input">
                <label for="host-phone">Номер телефона*</label>
                <input
                    type="text"
                    id="host-phone"
                    name="host"
                    placeholder="Введите номер телефона"
                    v-model="order.customer.phone"
                    :disabled="loading"
                    required
                />
              </div>
              <div class="recipient-content__input">
                <label for="host-mail">E-mail*</label>
                <input
                    type="text"
                    id="host-mail"
                    name="host"
                    placeholder="Введите E-mail"
                    v-model="order.customer.email"
                    :disabled="loading"
                    required
                />
              </div>
            </div>
          </form>
          <form class="recipient__msg">
            <label for="recipient__msg">Комментарий к заказу</label>
            <textarea
                name="recipient__msg"
                id="recipient__msg"
                placeholder="Введите комментарий"
                v-model="order.customer.description"
            ></textarea>
          </form>
        </div>
      </section>
      <section class="obtaining">
        <div class="cart-container">
          <div class="cart__title-wrap">
            <div class="cart__title-number">2</div>
            <div class="cart__title-block">
              <div class="cart__title">Выберите способ получения</div>
              <div class="cart__subtitle">
                <!--                Стоимость доставки <span> от 500 руб</span>.-->
                <!--                При заказе <span> от 10 000 руб</span> доставка <span> бесплатная</span>-->
              </div>
            </div>
          </div>
          <div class="obtaining-tabs">
            <div
                class="obtaining__tab"
                :class="{'obtaining__tab--active': !order.courier}"
                data-id="1"
                @click.prevent="changeDeliveryType(false)"
            >
              Пункт выдачи
            </div>
            <div
                class="obtaining__tab"
                :class="{'obtaining__tab--active': order.courier}"
                data-id="2"
                @click.prevent="changeDeliveryType(true)"
                v-if="checkAvalibleCourier"
            >
              Курьером
            </div>
          </div>
          <form class="obtaining__content-wrap">
            <div class="courier__max-weight" v-if="
              order.delivery.list !== null &&
              order.delivery.list[16] !== undefined &&
              order.delivery.list[16] !== null &&
              order.courier"
            >
              Доставка курьером 700 руб. <br>
              При заказе от 10 000 руб. доставка 200 руб.
            </div>

            <div class="courier__max-weight" v-if="
              order.delivery.list !== null &&
              !order.courier"
            >
              При заказе от 10 000 руб доставка бесплатная
            </div>

            <div class="obtaining__content-top">
              <div class="recipient-content__input">
                <label for="obtaining-sity">Выберите ваш город из списка:</label>
                <input
                    type="text"
                    id="obtaining-sity"
                    name="obtaining"
                    :disabled="loading"
                    autocomplete="off"
                    required
                />
              </div>
            </div>
            <div
                class="obtaining__content obtaining__content--active"
                v-if="order.delivery.city !== null &&
                order.delivery.city.length > 1 &&
                order.delivery.list !== null &&
                !order.courier"
                data-id="1"
            >
              <template v-for="delivery in order.delivery.list"
                        :key="delivery.ID">
                <div
                    v-if="parseInt(delivery.ID) !== 17 && parseInt(delivery.ID) !== 18"
                    class="obtaining__content-wrap"
                    :style="{ order: parseInt(delivery.SORT) }"
                >
                  <template
                      v-if="parseInt(delivery.ID) !== 16">
                    <div class="obtaining__content-title">
                      {{ delivery.NAME }}
                    </div>
                    <div
                        class="obtaining__content-card"
                        :class="{'obtaining__content-card--active': deliverySdek && parseInt(orderData.delivery_id) === parseInt(delivery.ID)}"
                        v-if="parseInt(delivery.ID) === 14 || parseInt(delivery.ID) === 15"
                        @click.prevent="showSdekWidjet(delivery.ID)"
                    >
                      <div class="obtaining__content-card__left">
                        <div class="obtaining__content-logo sdek">
                          <img :src="delivery.LOGO_PATH" :alt="delivery.NAME" :title="delivery.NAME">
                        </div>
                        <div class="obtaining__content-address">
                          Адрес: {{
                            order.delivery.deliveryAddress && parseInt(orderData.delivery_id) === parseInt(delivery.ID) ? order.delivery.deliveryAddress : 'ПВЗ не выбран'
                          }}
                        </div>
                        <div class="obtaining__content-date">
                          Cрок доставки: {{
                            order.delivery.estimated_delivery && parseInt(orderData.delivery_id) === parseInt(delivery.ID) ? order.delivery.estimated_delivery + 'дн.' : '-'
                          }}
                        </div>
                        <!--                      <div class="obtaining__content-date">-->
                        <!--                        Максимально допустимый вес: {{ parseInt(delivery.RESTRICTIONS.PARAMS.MAX_WEIGHT) / 1000  }} кг-->
                        <!--                      </div>-->
                        <div class="obtaining__content-button">Выбрать ПВЗ</div>
                      </div>
                      <div class="obtaining__content-card__right">
                        <div class="delivery__start-price">
                          500 руб
                        </div>
                      </div>
                    </div>
                    <div
                        class="obtaining__content-card"
                        :class="{'obtaining__content-card--active': deliveryRuPost && parseInt(orderData.delivery_id) === parseInt(delivery.ID)}"
                        v-if="parseInt(delivery.ID) === 9"
                        @click.prevent="showRuPostWidjet(delivery.ID)"
                    >
                      <div class="obtaining__content-card__left">
                        <div class="obtaining__content-logo ru_post">
                          <img :src="delivery.LOGO_PATH" :alt="delivery.NAME" :title="delivery.NAME">
                        </div>
                        <div class="obtaining__content-address">
                          Адрес: {{
                            order.delivery.deliveryAddress && parseInt(orderData.delivery_id) === parseInt(delivery.ID) ? order.delivery.deliveryAddress : 'ПВЗ не выбран'
                          }}
                        </div>
                        <div class="obtaining__content-date">
                          Cрок доставки: {{
                            order.delivery.estimated_delivery && parseInt(orderData.delivery_id) === parseInt(delivery.ID) ? order.delivery.estimated_delivery + 'дн.' : '-'
                          }}
                        </div>
                        <!--                      <div class="obtaining__content-date">-->
                        <!--                        Максимально допустимый вес: {{ parseInt(delivery.RESTRICTIONS.PARAMS.MAX_WEIGHT) / 1000  }} кг-->
                        <!--                      </div>-->
                        <div class="obtaining__content-button">Выбрать ПВЗ</div>
                      </div>
                      <div class="obtaining__content-card__right">
                        <div class="delivery__start-price">
                          500 руб
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>

            <div class="obtaining__content" data-id="2"
                 :class="(order.delivery.list !== null && order.delivery.list[16] !== undefined && order.delivery.list[16] !== null && order.courier)? 'd-block': 'd-none'"
                 v-show="order.delivery.list !== null && order.delivery.list[16] !== undefined && order.delivery.list[16] !== null">
              <div class="recipient-content__input recipient-content__input--nomargin">
                <label for="obtaining-street">Улица*</label>
                <input
                    type="text"
                    id="obtaining-street"
                    name="obtaining"
                    placeholder="Введите улицу"
                    v-model="order.delivery.street"
                    :disabled="loading || !showDetailDataCourier"
                    autocomplete="off"
                    required
                />
              </div>
              <div class="recipient-content__input-wrap">
                <div class="recipient-content__input">
                  <label for="obtaining-house">Дом*</label>
                  <input
                      type="text"
                      id="obtaining-house"
                      name="obtaining"
                      placeholder="Введите дом"
                      v-model="order.delivery.house"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
                <div class="recipient-content__input">
                  <label for="obtaining-kv">Кв./офис*</label>
                  <input
                      type="text"
                      id="obtaining-kv"
                      name="obtaining"
                      placeholder="Квартира/офис"
                      v-model="order.delivery.flat"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
              </div>
              <div class="recipient-content__input-wrap">
                <div class="recipient-content__input">
                  <label for="obtaining-entrance">Подъезд</label>
                  <input
                      type="text"
                      id="obtaining-entrance"
                      name="obtaining"
                      v-model="order.delivery.entrance"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
                <div class="recipient-content__input">
                  <label for="obtaining-floor">Этаж</label>
                  <input
                      type="text"
                      id="obtaining-floor"
                      name="obtaining"
                      v-model="order.delivery.level"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
                <div class="recipient-content__input">
                  <label for="obtaining-intercom">Домофон</label>
                  <input
                      type="text"
                      id="obtaining-intercom"
                      name="obtaining"
                      v-model="order.delivery.intercom"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
                <div class="recipient-content__input">
                  <label for="obtaining-intercom">Индекс</label>
                  <input
                      type="text"
                      readonly
                      v-model="order.delivery.postal_code"
                      :disabled="loading || !showDetailDataCourier"
                      autocomplete="off"
                      required
                  />
                </div>
              </div>
              <div
                  class="recipient-content__input recipient-content__input--nomargin"
              >
                <label for="date">Дата и время доставки</label>
                <input
                    type="text"
                    id="date"
                    name="obtaining"
                    placeholder="Завтра с 9:00 до 18:00"
                    v-model="order.delivery.delivery_date"
                    :disabled="loading || !showDetailDataCourier"
                    autocomplete="off"
                    required
                />
              </div>
            </div>

            <div
                class="additional_services"
                v-if="order.delivery.city !== null && order.delivery.city.length > 1 && order.delivery.list !== null"
            >
              <div class="additional_services__content-title">Дополнительные услуги</div>

              <template
                  v-if="order.delivery.list[orderData.delivery_id] !== undefined &&
                  Object.keys(order.delivery.list[orderData.delivery_id].EXTRA_SERVICES).length > 0"
              >
                <div
                    class="additional_services__service"
                    v-for="EXTRA_SERVICE in order.delivery.list[orderData.delivery_id].EXTRA_SERVICES"
                    :key="EXTRA_SERVICE.code"
                >
                  <div class="service__check-wrap">
                    <input
                        type="checkbox"
                        :id="'extra_service__' + EXTRA_SERVICE.code"
                        @change="setExtraService($event, EXTRA_SERVICE.code)"
                        :checked="EXTRA_SERVICE.value === 'Y'"
                        :disabled="loading"
                    >
                    <label :for="'extra_service__' + EXTRA_SERVICE.code">
                      <div class="service__check-round"></div>
                    </label>
                  </div>
                  <div class="service__check-title">
                    {{ EXTRA_SERVICE.name }}*
                    <span>{{ EXTRA_SERVICE.price }} р</span>
                  </div>
                </div>
              </template>

              <div class="additional_services__service">
                <div class="service__check-wrap">
                  <input
                      type="checkbox"
                      id="callback_manager_service"
                      name="callback_manager_service"
                      v-model="callback_manager_service"
                      :disabled="loading"
                  >
                  <label for="callback_manager_service">
                    <div class="service__check-round"></div>
                  </label>
                </div>
                <div class="service__check-title">
                  Наш менеджер свяжется с Вами чтобы ответить на ваши вопросы
                  <span>0р</span>
                </div>
              </div>


              <div
                  class="additional_services__description"
                  v-if="order.delivery.list[orderData.delivery_id] !== undefined &&
                    Object.keys(order.delivery.list[orderData.delivery_id].EXTRA_SERVICES).length > 0"
              >
                <p
                    class="description__item"
                    v-for="EXTRA_SERVICE in order.delivery.list[orderData.delivery_id].EXTRA_SERVICES"
                    :key="parseInt(EXTRA_SERVICE.id)"
                    v-html="EXTRA_SERVICE.description"
                ></p>
              </div>
            </div>
          </form>
        </div>
      </section>
      <section class="discounts"
               v-if="orderData.delivery_id && order.delivery.city && parseInt(orderData.delivery_id) !== 11">
        <div class="cart-container">
          <div class="cart__title-wrap">
            <div class="cart__title-number">3</div>
            <div class="cart__title">Ваши скидки</div>
          </div>
          <form class="discounts-form">
            <div class="discounts-form-element">
              <div class="discounts-form__img">
                <svg width="23" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.54182 0.965459C1.63315 1.21015 0.895281 1.98003 0.708875 2.87787C0.670574 3.06235 0.656315 3.93657 0.666046 5.50276C0.680201 7.78153 0.683792 7.85527 0.787923 7.99468C0.990358 8.26571 1.13893 8.33617 1.60823 8.38373C2.33626 8.45753 2.83985 8.69478 3.2989 9.1801C4.19658 10.1293 4.19658 11.6244 3.2989 12.5736C2.83985 13.0589 2.33626 13.2962 1.60823 13.37C1.13893 13.4175 0.990358 13.488 0.787923 13.759C0.683792 13.8984 0.680201 13.9722 0.666046 16.251C0.656315 17.8171 0.670574 18.6914 0.708875 18.8758C0.897675 19.7853 1.63825 20.5497 2.56409 20.7909C3.01471 20.9083 24.9389 20.9083 25.3895 20.7909C26.3153 20.5497 27.0559 19.7853 27.2447 18.8758C27.283 18.6914 27.2973 17.8171 27.2875 16.251C27.2734 13.9722 27.2698 13.8984 27.1657 13.759C26.9653 13.4908 26.8132 13.4172 26.3656 13.3721C25.6577 13.3007 25.2419 13.1202 24.7619 12.6758C23.7139 11.7055 23.7139 10.0482 24.7619 9.07789C25.2419 8.63352 25.6577 8.453 26.3656 8.3816C26.8132 8.33648 26.9653 8.26295 27.1657 7.99468C27.2698 7.85527 27.2734 7.78153 27.2875 5.50276C27.2973 3.93657 27.283 3.06235 27.2447 2.87787C27.0559 1.96842 26.3153 1.20401 25.3895 0.962857C24.9534 0.849254 2.96392 0.851752 2.54182 0.965459ZM25.2494 2.68381C25.3284 2.74283 25.4414 2.85575 25.5004 2.93475C25.6034 3.0726 25.6083 3.15306 25.6226 4.94807C25.6366 6.71341 25.6322 6.81786 25.5445 6.81947C25.3491 6.82311 24.5472 7.16985 24.2006 7.4006C23.2308 8.04615 22.5971 8.99791 22.3768 10.1399C22.005 12.0671 23.1332 14.0501 25.0072 14.7634C25.2516 14.8564 25.4934 14.9333 25.5445 14.9342C25.6322 14.9359 25.6366 15.0403 25.6226 16.8056C25.6083 18.6007 25.6034 18.6811 25.5004 18.819C25.4414 18.898 25.3284 19.0109 25.2494 19.0699L25.1057 19.1772H13.9768H2.84792L2.70419 19.0699C2.62514 19.0109 2.51221 18.898 2.4532 18.819C2.35021 18.6811 2.34532 18.6006 2.33106 16.8169L2.31618 14.9585L2.54349 14.8978C3.24113 14.7111 3.89074 14.3396 4.39459 13.8391C5.38215 12.858 5.82938 11.4572 5.57668 10.1364C5.27178 8.54277 4.09682 7.27143 2.54531 6.85647L2.31987 6.79616V5.01499C2.31987 3.1681 2.3321 3.04835 2.54453 2.81709C2.80025 2.53857 2.12753 2.55335 14.038 2.56532L25.1057 2.57651L25.2494 2.68381ZM15.5965 4.18339C13.6818 9.28132 10.7522 17.1138 10.7403 17.1665C10.7215 17.2499 12.2 17.8285 12.2611 17.7617C12.2821 17.7388 13.4008 14.7811 14.7471 11.1891C16.0935 7.59705 17.2088 4.62287 17.2258 4.57983C17.2498 4.51889 17.084 4.43688 16.4766 4.2092L15.6966 3.91679L15.5965 4.18339ZM9.63146 6.19832C8.62632 6.34445 7.73513 7.2539 7.57438 8.29745C7.39209 9.48084 8.14609 10.68 9.29794 11.0384C9.67294 11.1552 10.2929 11.1677 10.6723 11.0662C11.7602 10.7752 12.5209 9.78751 12.519 8.6687C12.5164 7.12 11.1765 5.97361 9.63146 6.19832ZM10.4639 7.95638C10.5497 8.00582 10.6747 8.12702 10.7417 8.22564C10.8423 8.37353 10.8601 8.4557 10.8434 8.69457C10.809 9.18572 10.5018 9.47178 10.0086 9.47178C9.70187 9.47178 9.45718 9.30567 9.30138 8.99182C9.13958 8.66574 9.1809 8.39393 9.43507 8.11261C9.71754 7.79995 10.0937 7.74281 10.4639 7.95638ZM18.0231 11.4016C17.4461 11.5377 16.7242 12.1025 16.4593 12.6252C16.2214 13.0947 16.1467 13.4497 16.1745 13.9796C16.1961 14.3941 16.2254 14.515 16.3861 14.8534C17.0026 16.1516 18.469 16.6742 19.7435 16.0501C20.7027 15.5804 21.2729 14.4961 21.1069 13.4572C20.9572 12.5198 20.2733 11.7205 19.3842 11.4438C19.0451 11.3382 18.3794 11.3176 18.0231 11.4016ZM19.082 13.1276C19.3374 13.2969 19.513 13.675 19.4658 13.9542C19.3885 14.4119 18.8881 14.7394 18.446 14.6215C17.9234 14.4823 17.678 13.9401 17.9132 13.4445C18.1089 13.0322 18.6972 12.8727 19.082 13.1276Z"
                        fill="#8a9b6e"/>
                </svg>
              </div>
              <div class="discounts-form__input">
                <label for="discounts">Мои промокоды</label>
                <div class="discounts-form__input-wrap">
                  <input type="text" name="discounts" id="discounts" placeholder="Введите промокод"
                         v-model="orderData.COUPON" :disabled="loading">
                  <button @click.prevent="setCoupon">
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.0235 0.0319455C10.9654 0.0529771 10.8862 0.09159 10.8475 0.117715C10.8088 0.14384 9.1954 1.74539 7.26225 3.67671L3.74744 7.18819L2.46207 5.90697C1.45011 4.89828 1.15172 4.61388 1.05933 4.56987C0.889649 4.48905 0.592178 4.4898 0.425568 4.57151C0.275929 4.64489 0.135139 4.78568 0.0617635 4.93532C-0.0198983 5.10186 -0.0206964 5.39935 0.06005 5.56908C0.104437 5.66236 0.43883 6.01023 1.68967 7.26422C3.48001 9.05913 3.40408 8.99524 3.74697 8.99524C3.92745 8.99524 3.95998 8.98794 4.08798 8.91888C4.20687 8.85476 4.84146 8.23 8.05732 5.01111C11.198 1.86752 11.895 1.15859 11.94 1.06231C12.0203 0.89058 12.0199 0.592875 11.9391 0.428542C11.8649 0.277565 11.7235 0.136986 11.5751 0.0665914C11.422 -0.00608031 11.1719 -0.0217837 11.0235 0.0319455Z"
                            fill="white"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="discounts-form-element bonuses-element" v-if="userData">
              <div class="discounts-form__img">
                <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M20.2587 6.84687L14.2087 6.32187L11.8462 0.759375C11.4212 -0.253125 9.9712 -0.253125 9.5462 0.759375L7.1837 6.33438L1.1462 6.84687C0.0461969 6.93437 -0.403803 8.30937 0.433697 9.03437L5.0212 13.0094L3.6462 18.9094C3.3962 19.9844 4.5587 20.8344 5.5087 20.2594L10.6962 17.1344L15.8837 20.2719C16.8337 20.8469 17.9962 19.9969 17.7462 18.9219L16.3712 13.0094L20.9587 9.03437C21.7962 8.30937 21.3587 6.93437 20.2587 6.84687ZM10.6962 14.7969L5.9962 17.6344L7.2462 12.2844L3.0962 8.68438L8.5712 8.20938L10.6962 3.17187L12.8337 8.22188L18.3087 8.69688L14.1587 12.2969L15.4087 17.6469L10.6962 14.7969Z"
                      fill="#8A9B6E"/>
                </svg>
              </div>
              <div class="discounts-form__input">
                <label for="bonuses">
                  <span>Доступные баллы</span>
                  <span class="bonuses">{{ basketStore.bonusesData }}</span>
                </label>
                <div class="discounts-form__input-wrap">
                  <input type="number" name="bonuses" id="bonuses" placeholder="Введите количество" v-model="bonuses"
                         :disabled="loading || payment_type === 'pay__dolyame' || orderData.COUPON !== '' || basketStore.bonusesData == '0'">
                  <button @click.prevent="setBonuses">
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.0235 0.0319455C10.9654 0.0529771 10.8862 0.09159 10.8475 0.117715C10.8088 0.14384 9.1954 1.74539 7.26225 3.67671L3.74744 7.18819L2.46207 5.90697C1.45011 4.89828 1.15172 4.61388 1.05933 4.56987C0.889649 4.48905 0.592178 4.4898 0.425568 4.57151C0.275929 4.64489 0.135139 4.78568 0.0617635 4.93532C-0.0198983 5.10186 -0.0206964 5.39935 0.06005 5.56908C0.104437 5.66236 0.43883 6.01023 1.68967 7.26422C3.48001 9.05913 3.40408 8.99524 3.74697 8.99524C3.92745 8.99524 3.95998 8.98794 4.08798 8.91888C4.20687 8.85476 4.84146 8.23 8.05732 5.01111C11.198 1.86752 11.895 1.15859 11.94 1.06231C12.0203 0.89058 12.0199 0.592875 11.9391 0.428542C11.8649 0.277565 11.7235 0.136986 11.5751 0.0665914C11.422 -0.00608031 11.1719 -0.0217837 11.0235 0.0319455Z"
                            fill="white"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      <section v-if="orderData.delivery_id && order.delivery.city && parseInt(orderData.delivery_id) !== 11"
               class="pay">
        <div class="cart-container">
          <div class="cart__title-wrap">
            <div class="cart__title-number">4</div>
            <div class="cart__title">Способ оплаты</div>
          </div>
          <form class="pay__form">
            <div class="pay__form-wrap">
              <div class="pay__form-check-wrap">
                <div
                    class="pay__form-check"
                    @click.prevent="changePayment(false, 'pay__online')"
                >
                  <input
                      type="radio"
                      id="pay__online"
                      class="online-pay"
                      name="pay"
                      value="pay__online"
                      :checked="payment_type === 'pay__online' && orderData.payment_id !== 1"
                      :disabled="loading"
                  />
                  <label for="pay__online">
                    <div class="pay__form-img">
                      <svg
                          width="28"
                          height="25"
                          viewBox="0 0 28 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.6646 1.34527C15.9345 2.08504 14.4345 2.75701 14.3314 2.83864C14.2282 2.92021 14.1131 3.07186 14.0757 3.17559C13.9905 3.41132 13.9733 7.43784 14.0535 8.34468C14.221 10.2362 14.703 11.7425 15.5629 13.0617C16.5136 14.5203 17.9945 15.846 20.0544 17.0824C20.9963 17.6478 21.0073 17.6478 21.9492 17.0824C25.1675 15.1506 26.9259 13.0647 27.6189 10.3566C27.9356 9.11924 28.0044 8.25157 27.9998 5.55254C27.9957 3.14522 27.9887 3.08718 27.6723 2.84121C27.3985 2.6284 21.2183 -0.000382915 20.9927 4.18373e-08C20.8768 0.000164166 19.664 0.490403 17.6646 1.34527ZM23.6687 2.9672L26.2538 4.0746L26.2537 5.88041C26.2537 6.87358 26.2287 7.95696 26.1981 8.28795C25.9209 11.2902 24.6856 13.1991 21.7741 15.1243C21.3855 15.3813 21.0397 15.5915 21.0057 15.5915C20.9717 15.5915 20.6969 15.4312 20.3949 15.2352C18.5256 14.0222 17.2566 12.7249 16.5963 11.3522C16.1815 10.4898 15.9125 9.44754 15.8055 8.28795C15.7749 7.95696 15.7499 6.87358 15.7499 5.88041L15.7498 4.0746L18.3074 2.97256C19.7141 2.36645 20.9142 1.86812 20.9743 1.86516C21.0344 1.86215 22.2469 2.35808 23.6687 2.9672ZM1.21389 5.35308C0.820972 5.48947 0.517342 5.71267 0.320447 6.00996C-0.0270586 6.53461 -0.00895016 6.01488 0.00686048 14.9924L0.0212487 23.1686L0.164584 23.4741C0.346762 23.8626 0.640161 24.156 1.02864 24.3382L1.33424 24.4815H13.9992H26.6641L26.9697 24.3382C27.3582 24.156 27.6516 23.8626 27.8338 23.4741L27.9771 23.1686V19.7397C27.9771 16.3618 27.9754 16.3085 27.8643 16.1596C27.65 15.8726 27.4751 15.783 27.1291 15.783C26.7831 15.783 26.6083 15.8725 26.3939 16.1596C26.2834 16.3076 26.2808 16.3757 26.2662 19.5345L26.2513 22.7582H13.9979H1.74455V17.5071V12.256L6.71358 12.2415L11.6826 12.2269L11.8893 12.0693C12.3799 11.6951 12.3589 11.0279 11.8445 10.6438C11.6949 10.532 11.6464 10.5308 6.719 10.5164L1.74455 10.5019V8.75297V7.004L6.71358 6.98951L11.6826 6.97495L11.8893 6.81729C12.3799 6.44308 12.3589 5.77592 11.8445 5.39181C11.6948 5.27999 11.6494 5.27889 6.5959 5.26669C1.80523 5.2551 1.48124 5.26029 1.21389 5.35308ZM23.251 5.34236C23.1246 5.40669 22.6155 5.99869 21.6499 7.20429C20.8713 8.1764 20.2161 8.97125 20.194 8.97065C20.1719 8.96999 19.9083 8.59782 19.6082 8.14352C18.9583 7.15959 18.8139 7.02966 18.3704 7.02966C17.8446 7.02966 17.5278 7.34757 17.5278 7.87523V8.19308L18.5126 9.66293C19.5644 11.2329 19.6984 11.376 20.1182 11.3781C20.5279 11.38 20.6045 11.3011 22.5447 8.87513C23.5651 7.59928 24.4231 6.49434 24.4515 6.41967C24.7174 5.72055 23.9175 5.00284 23.251 5.34236ZM4.0122 15.8315C3.64533 15.9936 3.44165 16.4103 3.52142 16.8356C3.56907 17.0896 3.91225 17.4328 4.165 17.4791C4.26299 17.4971 5.20681 17.5044 6.26229 17.4954L8.18145 17.4789L8.38803 17.3212C8.87854 16.947 8.85759 16.28 8.34323 15.8958C8.19792 15.7872 8.11668 15.7825 6.18565 15.7704C4.60075 15.7605 4.144 15.7733 4.0122 15.8315Z"
                            fill="#8A9B6E"
                        />
                      </svg>
                    </div>
                    <div class="pay__form-textblock">
                      <div class="pay__form-title">
                        Онлайн на сайте
                      </div>
                      <div class="pay__form-subtitle">
                        Быстро и удобно
                      </div>
                    </div>
                  </label>
                  <!--                  <div class="pay__form-check-decor">Скидка 5%</div>-->
                </div>

                <template
                    v-for="payment in order.payments"
                    :class="'payment__' + payment.ID"
                    :key="parseInt(payment.ID)"
                >
                  <div
                      class="pay__form-check"
                      v-if="parseInt(payment.ID) === 4 || parseInt(payment.ID) === 1 || parseInt(payment.ID) === 6"
                      @click.prevent="changePayment(parseInt(payment.ID), parseInt(payment.ID) === 4 ? 'pay__dolyame' : 'pay__offline_' + payment.ID)"
                  >
                    <input
                        type="radio"
                        id="pay__offline"
                        name="pay"
                        value="pay__offline"
                        :checked="payment_type === (parseInt(payment.ID) === 4 ? 'pay__dolyame' : 'pay__offline_' + payment.ID) && (orderData.payment_id === 4 || orderData.payment_id === 1  || orderData.payment_id === 6)"
                        :disabled="loading"
                    />
                    <label for="pay__offline">
                      <div class="pay__form-img">
                        <img width="28" height="28" :src="payment.LOGOTIP_SRC">
                      </div>
                      <div class="pay__form-textblock">
                        <div class="pay__form-title">
                          {{ payment.NAME }}
                        </div>
                        <div class="pay__form-subtitle">
                          {{ payment.DESCRIPTION }}
                        </div>
                      </div>
                    </label>
                  </div>
                </template>
              </div>
            </div>
            <div
                class="pay__form-wrap pay__form-wrap--online"
                :class="{'active': payment_type === 'pay__online'}"
                v-if="order.payments != null"
            >
              <div class="pay__form-wrap-title">Мы принимаем</div>
              <div class="pay__form-check-wrap">
                <!--pay__form-check--center-->
                <div
                    class="pay__form-check "
                    v-for="payment in order.payments"
                    :class="'payment__' + payment.ID"
                    :key="parseInt(payment.ID)"
                    @click.prevent="changePayment(parseInt(payment.ID), 'pay__online')"
                >
                  <template
                      v-if="parseInt(payment.ID) !== 1 && parseInt(payment.ID) !== 4 && parseInt(payment.ID) !== 6">
                    <input
                        type="radio"
                        id="pay__online2"
                        name="pay-online"
                        :value="parseInt(payment.ID)"
                        :checked="parseInt(payment.ID) === orderData.payment_id"
                        :disabled="loading"
                    />
                    <label for="pay__online2">
                      <div class="pay__form-img">
                        <img width="28" height="28" :src="payment.LOGOTIP_SRC">
                      </div>
                      <div class="pay__form-textblock">
                        <div class="pay__form-title">
                          {{ payment.NAME }} <span style="color: #f61902;">(скидка 3%)</span>
                        </div>
                        <div class="pay__form-subtitle">
                          {{ payment.DESCRIPTION }}
                        </div>
                      </div>
                    </label>
                  </template>
                </div>
                <!--                <div class="pay__form-check pay__form-check&#45;&#45;center">-->
                <!--                  <input-->
                <!--                      type="radio"-->
                <!--                      id="pay__online1"-->
                <!--                      name="pay-online"-->
                <!--                  />-->
                <!--                  <label for="pay__online1">-->
                <!--                    <div class="pay__form-img">-->

                <!--                    </div>-->
                <!--                    <div class="pay__form-textblock">-->
                <!--                      <div class="pay__form-title">СБП</div>-->
                <!--                      <div class="pay__form-subtitle">-->
                <!--                        Мгновенная оплата-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </label>-->
                <!--                </div>-->
              </div>
            </div>
            <div
                class="cart-products-order-wrap cart-products-order-wrap--mob"
            >
              <div class="cart-products-order">
                <div class="cart-products-order__title">Ваш заказ</div>

                <template v-if="loading">
                  <preloader-component/>
                </template>

                <template v-if="!loading">
                  <div class="cart-products-order__table">
                    <div class="cart-products-order__line">
                      <div
                          class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
                      >
                        Товары, {{ basketStore.basketData.prod_count }} шт.
                      </div>
                      <div
                          class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
                      >
                        {{ (basketStore.basketData.basket_data.price_without_discount) }} руб
                      </div>
                    </div>
                    <!--            <div class="cart-products-order__line">-->
                    <!--              <div-->
                    <!--                  class="cart-products-order__col cart-products-order__col&#45;&#45;1 cart-products-order__col&#45;&#45;products"-->
                    <!--              >-->
                    <!--                Вес заказа-->
                    <!--              </div>-->
                    <!--              <div-->
                    <!--                  class="cart-products-order__col cart-products-order__col&#45;&#45;2 cart-products-order__col&#45;&#45;productsPrice"-->
                    <!--              >-->
                    <!--                {{ (parseInt(orderData.basket_weight) / 1000).toFixed(2) }} кг-->
                    <!--              </div>-->
                    <!--            </div>-->
                    <div class="cart-products-order__line"
                         v-if="order.delivery.price !== null || order.delivery.price > 1">
                      <div
                          class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--delivery"
                      >
                        Доставка
                      </div>
                      <div
                          class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--deliveryPrice"
                      >
                        <template v-if="orderData.delivery_price && orderData.delivery_price > 0">
                          {{ orderData.delivery_price }} руб
                        </template>

                        <template v-if="orderData.delivery_price && orderData.delivery_price === 0">
                          Бесплатно
                        </template>
                      </div>
                    </div>
                    <div class="cart-products-order__line" style="margin-top: 1.5rem;">
                      <div
                          class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
                      >
                        Скидка
                        <!--                <span style="color: #e08b8b;">{{ (orderData.discount_percent).toFixed(0) }}%</span>-->
                      </div>
                      <div
                          class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
                          style="color: #e08b8b;"
                      >
                        {{ Math.round(orderData.discount_price) }} руб
                      </div>
                    </div>
                    <div class="cart-products-order__line" v-if="parseInt(orderData.BONUSES) !== 0"
                         style="margin-top: 1.5rem;">
                      <div
                          class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
                      >
                        Будет оплачено бонусами
                      </div>
                      <div
                          class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
                          style="color: #e08b8b;"
                      >
                        {{ Math.round(orderData.BONUSES !== '' ? parseInt(orderData.BONUSES) : 0) }} руб
                      </div>
                    </div>
                    <div class="cart-products-order__line">
                      <div
                          class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--total"
                      >
                        Итого:
                      </div>
                      <div
                          class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--totalPrice"
                      >
                        {{
                          Math.round(parseInt(orderData.price) + parseInt(orderData.delivery_price) - (orderData.BONUSES !== '' ? parseInt(orderData.BONUSES) : 0))
                        }} руб
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="discounts-form">
                <div class="discounts-form__input">
                  <div class="discounts-form__input-wrap">
                    <input
                        type="text"
                        name="discounts"
                        id="discounts"
                        placeholder="Введите промокод"
                        v-model="orderData.COUPON"
                        :disabled="loading"
                    />
                    <button @click.prevent="setCoupon">
                      <svg
                          width="12"
                          height="9"
                          viewBox="0 0 12 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0235 0.0319455C10.9654 0.0529771 10.8862 0.09159 10.8475 0.117715C10.8088 0.14384 9.1954 1.74539 7.26225 3.67671L3.74744 7.18819L2.46207 5.90697C1.45011 4.89828 1.15172 4.61388 1.05933 4.56987C0.889649 4.48905 0.592178 4.4898 0.425568 4.57151C0.275929 4.64489 0.135139 4.78568 0.0617635 4.93532C-0.0198983 5.10186 -0.0206964 5.39935 0.06005 5.56908C0.104437 5.66236 0.43883 6.01023 1.68967 7.26422C3.48001 9.05913 3.40408 8.99524 3.74697 8.99524C3.92745 8.99524 3.95998 8.98794 4.08798 8.91888C4.20687 8.85476 4.84146 8.23 8.05732 5.01111C11.198 1.86752 11.895 1.15859 11.94 1.06231C12.0203 0.89058 12.0199 0.592875 11.9391 0.428542C11.8649 0.277565 11.7235 0.136986 11.5751 0.0665914C11.422 -0.00608031 11.1719 -0.0217837 11.0235 0.0319455Z"
                            fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button class="pay__button" @click.prevent="createVirtualOrder(1)" :disabled="loading">оформить заказ
            </button>
          </form>
        </div>
      </section>
    </div>
    <div class="cart-products-order-wrap">
      <div class="cart-products-order">
        <div class="cart-products-order__title">Ваш заказ</div>

        <template v-if="loading">
          <preloader-component/>
        </template>

        <template v-if="!loading">
          <div class="cart-products-order__table">
            <div class="cart-products-order__line">
              <div
                  class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
              >
                Товары, {{ basketStore.basketData.prod_count }} шт.
              </div>
              <div
                  class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
              >
                {{ (basketStore.basketData.basket_data.price_without_discount) }} руб
              </div>
            </div>
            <!--            <div class="cart-products-order__line">-->
            <!--              <div-->
            <!--                  class="cart-products-order__col cart-products-order__col&#45;&#45;1 cart-products-order__col&#45;&#45;products"-->
            <!--              >-->
            <!--                Вес заказа-->
            <!--              </div>-->
            <!--              <div-->
            <!--                  class="cart-products-order__col cart-products-order__col&#45;&#45;2 cart-products-order__col&#45;&#45;productsPrice"-->
            <!--              >-->
            <!--                {{ (parseInt(orderData.basket_weight) / 1000).toFixed(2) }} кг-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="cart-products-order__line" v-if="order.delivery.price !== null || order.delivery.price > 1">
              <div
                  class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--delivery"
              >
                Доставка
              </div>
              <div
                  class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--deliveryPrice"
              >
                <template v-if="orderData.delivery_price > 0">
                  {{ orderData.delivery_price }} руб
                </template>

                <template v-if="orderData.delivery_price === 0">
                  Бесплатно
                </template>
              </div>
            </div>
            <div class="cart-products-order__line" style="margin-top: 1.5rem;">
              <div
                  class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
              >
                Скидка
                <!--                <span style="color: #e08b8b;">{{ (orderData.discount_percent).toFixed(0) }}%</span>-->
              </div>
              <div
                  class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
                  style="color: #e08b8b;"
              >
                {{ Math.round(orderData.discount_price) }} руб
                <!-- {{ (orderData.discount_percent).toFixed(2) }} % -->
              </div>
            </div>
            <div class="cart-products-order__line" v-if="parseInt(orderData.BONUSES) !== 0" style="margin-top: 1.5rem;">
              <div
                  class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--products"
              >
                Будет оплачено бонусами
              </div>
              <div
                  class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--productsPrice"
                  style="color: #e08b8b;"
              >
                {{ Math.round(orderData.BONUSES !== '' ? parseInt(orderData.BONUSES) : 0) }} руб
              </div>
            </div>
            <div class="cart-products-order__line">
              <div
                  class="cart-products-order__col cart-products-order__col--1 cart-products-order__col--total"
              >
                Итого:
              </div>
              <div
                  class="cart-products-order__col cart-products-order__col--2 cart-products-order__col--totalPrice"
              >
                {{
                  Math.round(parseInt(orderData.price) + parseInt(orderData.delivery_price) - (orderData.BONUSES !== '' ? parseInt(orderData.BONUSES) : 0))
                }} руб
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <vue-final-modal v-model="showModal">
      <div class="close-modal" @click="showModal = false">
        Закрыть окно выбора
      </div>
      <div id="sdekpvz" ref="sdekpvz" v-show="deliverySdek"></div>
      <div id="rupost" ref="rupost" v-show="deliveryRuPost"></div>
    </vue-final-modal>
  </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {useBasketStore} from "../store/basket";
import {usePersonalStore} from "../store/personal";
import basketOrderComponent from "./basketOrderComponent";

import {mapStores} from 'pinia';

export default {
  name: "orderComponent",
  props: [
    'grecaptchaSiteKey',
    'dadataToken',
    'userData',
    'coupon',
    'couponBonus',
    'host'
  ],
  components: {
    basketOrderComponent
  },
  data() {
    return {
      bonuses: 0,
      payment_type: 'pay__online',
      showModal: false,
      deliverySdek: false,
      deliveryRuPost: false,
      callback_manager_service: true,
      loading: true,
      toast: useToast(),
      basketStore: useBasketStore(),
      personalStore: usePersonalStore(),
      sdekWidjet: null,
      order: {
        any_receive: Object.keys(this.userData).length <= 0,
        courier: false,
        PERSON_TYPE_ID: 1,
        customer: {
          name: this.userData.NAME ?? '',
          lastname: this.userData.LAST_NAME ?? '',
          phone: this.userData.PHONE_NUMBER ?? '',
          email: this.userData.EMAIL ?? '',
          description: ''
        },
        delivery: {
          list: null,
          city: '',
          cityCode: '',
          street: '',
          house: '',
          flat: '',
          entrance: '',
          level: '',
          intercom: '',
          postal_code: '',
          delivery_date: '',
          geo_lat: '',
          geo_lon: '',
          deliveryAddress: '',
          deliveryAddressComment: '',
          estimated_delivery: '',
          price: ''
        },
        payments: null
      },
      dadata: {
        city: 'obtaining-sity',
        street: 'obtaining-street',
        house: 'obtaining-house',
        type: 'ADDRESS'
      },
      orderData: {
        PERSON_TYPE_ID: 1,
        FIO: '',
        EMAIL: '',
        PHONE: '',
        ZIP: '',
        SHADOW_LOCATION: '',
        LOCATION_ID: '',
        LOCATION: '',
        delivery_id: 11,
        delivery_price: '',
        delivery_extra_services: [],
        payment_id: 0, //3,
        basket_weight: '',
        basket_base_price: 0,
        discount_price: 0,
        discount_percent: 0,
        price: 0,
        COUPON: '',
        BONUSES: 0,
        save: 0,
      },
      paramsPostWidjet: {
        'allmongolia.ru': 40139,
        'msk.allmongolia.ru': 40143
      },
      showDetailDataCourier: false,
    }
  },
  watch: {
    'basketStore.basketData.items'(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        this.createVirtualOrder();
      }
    }
  },
  computed: {
    throttledSendSuggest() {
      return lodash.throttle(this.getSuggest, 1000)
    },
    checkPayment() {
      for (const paymentIndex in this.order.payments) {
        if (parseInt(this.order.payments[paymentIndex].ID) === 4) return 4;

        if (parseInt(this.order.payments[paymentIndex].ID) === 1) return 1;

        // console.log(this.order.payments[paymentIndex])
      }
    },
    checkAvalibleCourier() {
      if (this.order && this.order.delivery && this.order.delivery.list) {
        return this.order.delivery.list.hasOwnProperty(16);
      }
      // return this.order.delivery.list.hasOwnProperty(16);
    }
  },
  methods: {
    changePayment(payment_id = false, payment_type) {
      if (payment_type === 'pay__online' && payment_id !== false) {
        this.payment_type = payment_type;
        this.orderData.payment_id = payment_id;
        this.createVirtualOrder();

      } else if (payment_type === 'pay__online') {
        this.payment_type = payment_type;

      } else if (payment_type === 'pay__dolyame') {
        this.payment_type = payment_type;
        this.orderData.payment_id = payment_id;

        if (parseInt(this.orderData.BONUSES) > 0 || parseInt(this.bonuses) > 0) {
          this.orderData.BONUSES = 0;
          this.bonuses = 0;
          this.toast.info('Списание бонусов не доступно, так как выбрана оплата долями');
        }
        this.createVirtualOrder();

      } else if (payment_type === 'pay__offline_' + payment_id && payment_id !== false) {
        this.payment_type = 'pay__offline_' + payment_id;
        this.orderData.payment_id = payment_id;
        this.createVirtualOrder();
      }
    },
    changeLocationData() {
      this.createVirtualOrder();
    },
    changeDeliveryType(courier = false) {
      this.order.courier = courier;

      if (courier) {
        this.orderData.delivery_id = 16;
      } else {
        this.orderData.delivery_id = 11;
      }
    },
    createVirtualOrder(save = 0, setCoupon = 0) {
      this.loading = true;

      if (save !== 0) {
        this.orderData.save = 1;
      }

      let formData = new FormData();

      formData.append('PERSON_TYPE_ID', this.order.PERSON_TYPE_ID);
      formData.append('customer_name', this.order.customer.name);
      formData.append('customer_lastname', this.order.customer.lastname);
      formData.append('customer_phone', this.order.customer.phone);
      formData.append('customer_email', this.order.customer.email);
      formData.append('customer_description', this.order.customer.description);

      formData.append('delivery_id', this.orderData.delivery_id);
      formData.append('payment_id', this.orderData.payment_id);
      formData.append('zipcode', this.order.delivery.postal_code);
      formData.append('COUPON', this.orderData.COUPON);
      formData.append('delivery_city', this.order.delivery.city);
      formData.append('delivery_address', this.order.delivery.deliveryAddress);
      formData.append('set_coupon', setCoupon);

      if (this.orderData.COUPON !== '') {
        this.orderData.BONUSES = 0;
      }

      formData.append('BONUSES', this.orderData.BONUSES ?? 0);
      formData.append('any_receive', this.order.any_receive);
      formData.append('courier', this.order.courier);

      formData.append('delivery_extra_services', JSON.stringify(this.orderData.delivery_extra_services));
      formData.append('callback_manager_service', this.callback_manager_service);

      formData.append('save', save);

      // if (this.orderData.BONUSES > this.basketStore.bonusesData) {
      //   this.toast.error('Вы ввели недопустимое количество баллов');
      // } else {
      if (this.order.courier) {
        formData.append('courier_info', JSON.stringify(this.order.delivery));
      } else {
        formData.append('courier_info', JSON.stringify({}));
      }

      axios.post('/local/api/handlers/Order/order.php', formData)
          .then(response => {
            this.orderData.delivery_price = response.data.order.delivery_price;
            // this.orderData.discount_price = response.data.order.discount_price;
            // this.orderData.price = response.data.order.price;

            // Результаты правильного расчета стоимости
            // и суммы всех скидок
            this.orderData.discount_price = response.data.order.final_discount;
            this.orderData.price = response.data.order.final_price;

            this.orderData.discount_percent = response.data.order.discount_percent;

            this.orderData.basket_base_price = response.data.basket.base_price;
            this.orderData.basket_weight = response.data.order.basket_weight;

            if (response.data.delivery[response.data.delivery_id]) {
              this.order.delivery.estimated_delivery = response.data.delivery[response.data.delivery_id].DELIVERY_PERIOD;
            }

            this.order.delivery.list = response.data.delivery;
            this.order.payments = response.data.payments;


            // if (setCoupon === 1) {
            //   this.toast.success('Ваш промокод применен');
            // }

            // Object.assign(this.basketData, response.data)
            // if (response.data.success === 1) {
            //     this.toast.success(response.data.msg);
            //
            //     console.log(response.data);
            // } else {
            //     this.toast.error(response.data.msg);
            // }

            let couponList = Object.keys(response.data.order.discount_list.COUPON_LIST)
            if (couponList.length > 0) {
              this.orderData.COUPON = couponList[0]
            }

            // Добавляем экстра-сервисы по умолчанию
            if (response.data.delivery[response.data.delivery_id] !== undefined &&
                Object.keys(response.data.delivery[response.data.delivery_id].EXTRA_SERVICES).length > 0) {
              _.forEach(response.data.delivery[response.data.delivery_id].EXTRA_SERVICES, (service) => {
                if (_.indexOf(this.orderData.delivery_extra_services, parseInt(service.id)) === -1 && service.value === 'Y') {
                  this.orderData.delivery_extra_services.push(service.code);
                }
              });
            }

            this.basketStore.getBasket()
                .finally(() => {
                  this.loading = false;
                });

            if (response.data.errors.length > 0) {
              response.data.errors.forEach(el => {
                this.toast.error(el);
              })
            }

            if (response.data.msg.length > 0) {
              response.data.msg.forEach(el => {
                this.toast.info(el);
              })
            }

            // Отправка цели на покупку
            if (this.orderData.save === 1 && this.host === "msk.allmongolia.ru") {
              window.ym(90812209, 'reachGoal', 'new_purchase');
            }

            // if (this.orderData.save === 1 && this.host === "allmongolia.ru") {
            //
            // }

            if (response.data.success === 'Y') {
              window.location.replace(response.data.payment_link);
            }

            if (this.userData) {
              this.basketStore.getBonuses(this.userData.ID, response.data.basket.items);
            }

            return response.data;
          })
          .catch((error) => {
            this.toast.error("При создании заказа произошла ошибка");

            if (setCoupon === true) {
              this.toast.error('Ошибка при применении купона');
            }
          })
          .finally(() => {
            this.loading = false;
          })
      // }
    },
    getSuggest() {
      axios.post('/local/api/handlers/DaData/DaDataClass.php?action=suggest', {
        city: this.order.delivery.city
      })
          .then(response => {
            // Object.assign(this.basketData, response.data)
            // if (response.data.success === 1) {
            //     this.toast.success(response.data.msg);
            //
            //     console.log(response.data);
            // } else {
            //     this.toast.error(response.data.msg);
            // }

            return response.data;
          })
          .catch((error) => {
            this.toast.error("При создании виртуального заказа произошла ошибка");
          })
          .finally(() => {
          })
    },
    suggestsInit() {
      $(`#${this.dadata.city}`).suggestions({
        token: this.dadataToken,
        type: this.dadata.type,
        bounds: "city-settlement",
        formatSelected: this.formatSelectedDaData,
      });

      // улица
      $(`#${this.dadata.street}`).suggestions({
        token: this.dadataToken,
        type: this.dadata.type,
        hint: false,
        bounds: "street",
        constraints: $(`#${this.dadata.city}`),
        onSelect: (suggestion) => {
          this.order.delivery.street = suggestion.value;
          this.order.delivery.geo_lat = suggestion.data.geo_lat;
          this.order.delivery.geo_lon = suggestion.data.geo_lon;

          if (suggestion.data.postal_code) {
            this.order.delivery.postal_code = suggestion.data.postal_code;
          }
          this.changeLocationData();
        }
      });

      // дом
      $(`#${this.dadata.house}`).suggestions({
        token: this.dadataToken,
        type: this.dadata.type,
        hint: false,
        bounds: "house",
        constraints: $(`#${this.dadata.street}`),
        onSelect: (suggestion) => {
          this.order.delivery.house = suggestion.value;
          this.order.delivery.geo_lat = suggestion.data.geo_lat;
          this.order.delivery.geo_lon = suggestion.data.geo_lon;

          if (suggestion.data.postal_code) {
            this.order.delivery.postal_code = suggestion.data.postal_code;
          }

          this.changeLocationData();
        }
      });
    },
    joinForDaData(arr) {
      let separator = arguments.length > 1 ? arguments[1] : ", ";
      return arr
          .filter(function (n) {
            return n;
          })
          .join(separator);
    },
    makeAddressStringDaData(address) {
      return this.joinForDaData([
        address.city,
        address.settlement,
      ]);
    },
    formatSelectedDaData(suggestion) {
      let addressValue = this.makeAddressStringDaData(suggestion.data);
      this.order.delivery.city = addressValue;
      // this.order.delivery.city = suggestion.value;
      this.order.delivery.geo_lat = suggestion.data.geo_lat;
      this.order.delivery.geo_lon = suggestion.data.geo_lon;
      if (suggestion.data.postal_code) {
        this.order.delivery.postal_code = suggestion.data.postal_code;
      }

      this.sdekWidjetInit(this.order.delivery.city);

      this.$refs.rupost.innerHTML = '';
      this.order.delivery.deliveryAddress = '';
      this.order.delivery.deliveryAddressComment = '';
      this.order.delivery.estimated_delivery = '';
      this.ruPostInit(this.order.delivery.postal_code);
      this.showDetailDataCourier = true;
      this.createVirtualOrder();
    },
    sdekWidjetInit(city) {
      this.sdekWidjet = new ISDEKWidjet({
        // popup: true,
        showWarns: true,
        showErrors: true,
        showLogs: true,
        hidedelt: true,
        hideMessages: false,
        path: '/local/templates/allmongolia_umax/assets/js/sdekpvzwidget/scripts/',
        servicepath: '/local/templates/allmongolia_umax/assets/js/sdekpvzwidget/scripts/service.php', //ссылка на файл service.php на вашем сайте
        templatepath: '/local/templates/allmongolia_umax/assets/js/sdekpvzwidget/scripts/template.php',
        country: 'Россия',
        defaultCity: city,
        // choose: true,
        link: 'sdekpvz',
        onChoose: this.onChooseSdekWidjet,
      });
    },
    ruPostInit(zipcode) {
      ecomStartWidget({
        id: this.paramsPostWidjet[this.host],
        weight: this.orderData.basket_weight,
        sumoc: this.orderData.basket_base_price,
        callbackFunction: this.onChooseRuPost,
        startZip: zipcode,
        containerId: 'rupost'
      });
    },
    showSdekWidjet(delivery_id) {
      if (this.order.delivery.city !== null || this.order.delivery.city > 1) {
        this.deliverySdek = true;
        this.deliveryRuPost = false;
        this.showModal = true;
        this.orderData.delivery_id = delivery_id;
      } else {
        this.toast.error('Необходимо ввести город');
      }
    },
    showRuPostWidjet(delivery_id) {
      if (this.order.delivery.city !== null || this.order.delivery.city > 1) {
        this.deliveryRuPost = true;
        this.deliverySdek = false;
        this.showModal = true;
        this.orderData.delivery_id = delivery_id;
      } else {
        this.toast.error('Необходимо ввести город');
      }
    },
    onChooseSdekWidjet(wat) {
      this.order.delivery.deliveryAddress = `г ${this.order.delivery.city}, ${wat.PVZ.Address} #${wat.id}`;
      this.order.delivery.deliveryAddressComment = wat.PVZ.AddressComment;
      // this.order.delivery.sdekEstimated_delivery = wat.term;
      this.order.delivery.cityCode = wat.city;
      // this.order.delivery.price = wat.price;

      this.showModal = false;
      this.createVirtualOrder();
    },
    onChooseRuPost(data) {
      this.order.delivery.deliveryAddress = `г ${this.order.delivery.city}, ${data.addressTo}`;
      this.order.delivery.deliveryAddressComment = '';
      // this.order.delivery.rupostEstimated_delivery = `${data.deliveryDescription.values.deliveryMin}-${data.deliveryDescription.values.deliveryMax}`;
      // this.order.delivery.price = Math.ceil(data.cashOfDelivery / 100);
      this.order.delivery.postal_code = data.indexTo;

      this.showModal = false;
      this.createVirtualOrder();
    },
    setCoupon() {
      this.createVirtualOrder(0, 1);
    },
    setBonuses() {
      this.orderData.BONUSES = this.bonuses;
      this.createVirtualOrder();
    },
    setExtraService(event, code) {
      // delivery_extra_services
      if (event.target.checked && _.indexOf(this.orderData.delivery_extra_services, code) === -1) {
        this.orderData.delivery_extra_services.push(code)
      } else if (!event.target.checked && _.indexOf(this.orderData.delivery_extra_services, code) !== -1) {
        this.orderData.delivery_extra_services.splice(_.indexOf(this.orderData.delivery_extra_services, code), 1);
        // this.orderData.delivery_extra_services = _.remove(this.orderData.delivery_extra_services, (num) => {
        //   return num === parseInt(id);
        // });
      }
      this.createVirtualOrder(0, 0);
    }
  },
  mounted() {
    this.basketStore.getBasket()
        .finally(() => {
          this.loading = false;

          this.suggestsInit();

          // if (this.orderData.save === 0 && this.basketStore.basketData.items.length !== 0) {
          //   this.createVirtualOrder();
          // }

          if (this.orderData.save === 0 && _.size(this.basketStore.basketData.items) > 0) {
            this.createVirtualOrder();
          }

          this.basketStore.$subscribe((mutation, state) => {
            // console.log(state)
            // if (this.orderData.save === 0 && _.size(state.basketData.items) > 0) {
            //   // this.createVirtualOrder();
            // }
            //
            if (this.orderData.save === 0 && _.size(state.basketData.items) === 0) {
              window.location.replace('/cart/');
            }
          })
        });

  },
}
</script>

<style>
</style>
